import { render, staticRenderFns } from "./PageLicense.vue?vue&type=template&id=c1be92be&scoped=true&lang=pug&"
import script from "./PageLicense.vue?vue&type=script&lang=js&"
export * from "./PageLicense.vue?vue&type=script&lang=js&"
import style0 from "./PageLicense.vue?vue&type=style&index=0&id=c1be92be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1be92be",
  null
  
)

export default component.exports